'use client';

import { AnimatePresence, motion } from 'framer-motion';
export const AnimateBottomToTop = ({
  children,
  delay = 0.3,
  y = 20
}: any) => <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="AnimateBottomToTop" data-sentry-source-file="AnimateBottomToTop.tsx">
    <motion.div initial={{
    opacity: 0,
    y
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: 0
  }} transition={{
    delay,
    duration: 0.35
  }} data-sentry-element="unknown" data-sentry-source-file="AnimateBottomToTop.tsx">
      {children}
    </motion.div>
  </AnimatePresence>;